(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay = document.getElementById('email-popup-overlay');
    if (!overlay) return;

    function closePopup() {
      overlay.style.display = 'none';
      localStorage.setItem('fabEmailPopupShown', 'true');
    }

    var closeBtn = document.getElementById('email-popup-close-btn');
    var successClose = document.getElementById('email-popup-success-close');
    var form = document.getElementById('email-popup-form');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (successClose) successClose.addEventListener('click', closePopup);
    if (form) form.addEventListener('submit', function () {
      localStorage.setItem('fabEmailPopupShown', 'true');
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    // Show popup on first visit after 2s
    if (!localStorage.getItem('fabEmailPopupShown')) {
      setTimeout(function () {
        overlay.style.display = 'flex';
      }, 2000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
